const isSelfMadeOptions = [{
  key: '是',
  value: 0
},
  {
    key: '否',
    value: 1
  }
];
const cardType = [
  {id:'RESIDENT_IDENTITY_CARD',text:'居民身份证'},
  {id:'MILITARY_ID_CARD',text:'军官证'},
  {id:'PASSPORT',text:'护照'},
  {id:'HONG_KONG_AND_MACAU_PASS',text:'港澳通行证'},
  {id:'DRIVER_LICENSE',text:'驾驶证'},
  {id:'OTHER',text:'其他'},
];
const sexOptions = [
  {id:0,text:'男'},
  {id:1,text:'女'},
  {id:2,text:'保密'}
];
const newsTypeOptions = [
  {id:0,text:'资讯新闻'},
  {id:1,text:'法律法规'},
  {id:2,text:'推荐知识'},
];
export default {
  isSelfMadeOptions,
  cardType,
  sexOptions,
  newsTypeOptions
}



//////////////////
// WEBPACK FOOTER
// ./static/js/selectOpitons.js
// module id = null
// module chunks = 